require('./validator');

import $ from 'jquery';
import validate from 'jquery-validation';
import { getTranslatedMessages } from '../../translates';
import { setupEsLocationSelects } from './es-location-helper';
import { addUTMParamsToForm } from '../../common/utmTracking';
validate;

function setupPhoneInput(container) {
    container.find('input[name="phone"]').on('input', function () {
        $(this).val($(this).val().replace(/\D/g, '').slice(0, 13));
    });
}

function setupContactForm() {
    var $contactForm = $('.contact-form');
    var $btnSubmit = $contactForm.find('.btn-submit');

    setInterval(function () {
        try {
            reloadCaptcha('contact');
        } catch (e) {
            console.log(e);
        }
    }, 60000);

    $contactForm.validate({
        rules: {
            name: 'required',
            email: {
                required: true,
                email: true,
            },
            phone: {
                required: true,
                minlength: 8,
                maxlength: 13,
            },
            es_province_id: { number: true, required: true },
            es_department_id: { number: true, required: true },
            es_city_id: { number: true, required: true },

            contact_subject_id: { number: true, required: true },
            message: { required: true, maxlength: 400 },
            privacy: 'required',
        },
        messages: getTranslatedMessages(),
        submitHandler: function (form, event) {
            if ($btnSubmit.hasClass('loading')) {
                return;
            }

            $btnSubmit.addClass('loading');

            event.preventDefault();
            event.stopPropagation();

            var $form = $(form);
            addUTMParamsToForm($form[0]);

            $.ajax({
                type: 'POST',
                url: $form.data('action'),
                data: $form.serialize(),
                success: function (data) {
                    form.reset();
                    $contactForm.find('.form').addClass('hidden');
                    $contactForm.find('.response').removeClass('hidden');
                    $contactForm.find('.form-feedback').html(data);
                    $btnSubmit.removeClass('loading');
                },
                error: function (data) {
                    $contactForm.find('.form-feedback').empty();
                    $btnSubmit.removeClass('loading');

                    var $formErrors = $contactForm.find('.form-errors');
                    $formErrors
                        .html(
                            data.responseJSON && data.responseJSON.errors
                                ? Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>')
                                : data.responseJSON.message || data.responseText
                        )
                        .show({ duration: 0 });

                    try {
                        reloadCaptcha('contact');
                    } catch (e) {
                        console.log(e);
                    }
                },
            });
        },
    });
}

function initialize() {
    setupContactForm();
    setupPhoneInput($('.contact-form'));
    setupEsLocationSelects($('.contact-form'), {
        provinceName: 'es_province_id',
        departmentName: 'es_department_id',
        cityName: 'es_city_id',
        visibilityMode: true,
    });
}

initialize();
